import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestMigrationDelete = {
    path: "/migration/:migration",
    method: RouteHttpVerb.DELETE
};
